<template>
  <div class="relative h-full w-full">
    <l-map
      ref="map"
      @ready="onReady()"
      class="h-full w-full z-0"
      :zoom="zoom"
      :maxZoom="maxZoom"
      :center="center"
      :options="mapOptions"
    >
      <l-tile-layer :url="urlBaseMap" :attribution="attribution"></l-tile-layer>
      <template v-for="(levantamiento, index) in levantamientos">
        <template v-for="(feature, index_feature) in levantamiento.geojson.features">
        <l-layer-group :key="feature.properties.id" ref="features">
          <l-geo-json
            :geojson="feature"
            :options="geoJsonOptions"
            :options-style="styleFunction(feature, levantamiento.tipo_nombre)"
            @click="showPopup(levantamiento, feature.properties.id, $event)"
          >
          </l-geo-json>
            <l-popup>
              <div v-if="(levantamiento.media_metadata != null) && (levantamiento.file_type != 'audio/mpeg')" style="width: ${this.imageWidthPopup}">
                <div class="pt-2 pb-2">
                  <div v-if="levantamiento.tipo_nombre == 'Oportunidad'" class="flex flex-col items-center text-center" style="color: #6ca929;"> <!--div sección o table row -->
                    <div class="text-xl font-semibold leading-normal">
                      {{ levantamiento.nombre }}
                    </div>
                    <div v-if="levantamiento.descripcion == ''" class="text-xs font-normal italic leading-normal text-justify" style="padding-top: 10px;">
                      {{ levantamiento.descripcion }}
                    </div>
                  </div>
                  <div v-else class="flex flex-col items-center text-center text-cdmx-red"> 
                    <div class="text-xl font-normal leading-normal">
                      {{ levantamiento.nombre }}
                    </div>
                    <div class="text-xs font-light italic leading-normal text-justify" style="padding-top: 10px;">
                      {{ levantamiento.descripcion }}
                    </div>
                  </div>
                  <div v-if="levantamiento.media_folder != null" class="flex flex-col items-center text-center pt-3 pb-2 max-h-fit"> 
                    <!-- <div v-if="levantamiento.file_type == 'image/jpeg'" class="font-bold">Imagen:</div> -->
                    <div v-if="levantamiento.file_type == 'image/jpeg'" class='text-right' >
                      <div v-if="levantamiento.tipo_nombre == 'Oportunidad'" class="rounded-md border-solid border-2 border-cdmx-green">
                        <v-lazy-image :src="levantamiento.imagen" class="max-w-full" style="height:130px;"/>
                      </div>
                      <div v-else class="rounded-md border-solid border-2 border-cdmx-red">
                        <v-lazy-image :src="levantamiento.imagen" class="max-w-full" style="height:130px;"/>
                      </div>
                      <!--<small @click="showImage(levantamiento.imagen)" style="cursor: pointer; color: #007bff;">Ver imagen completa</small> -->
                    </div>
                    <!-- <div v-if="levantamiento.file_type == 'video/mp4'" class="font-bold">Video:</div> -->
                    <div v-if="levantamiento.file_type == 'video/mp4'">
                      <div v-if="levantamiento.tipo_nombre == 'Oportunidad'" class="rounded-md border-solid border-2 border-cdmx-green">
                        <video
                          :src="levantamiento.video"
                          controls
                          controlsList="nodownload"
                          style="height:130px;"
                        />
                      </div>
                      <div v-else class="rounded-md border-solid border-2 border-cdmx-red">
                        <video
                          :src="levantamiento.video"
                          controls
                          controlsList="nodownload"
                          style="height:130px;"
                        />
                      </div>
                    </div>
                    <!-- <div v-if="levantamiento.file_type == 'audio/mpeg'" class="font-bold">Audio:</div> -->                  
                    <button v-if="levantamiento.file_type == 'image/jpeg'" class="mt-4 text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium 
                    rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" style="cursor:pointer;"
                    type="button" @click="openMultimediaModal(levantamiento)"> Ver imagen </button>
                    <button v-if="levantamiento.file_type == 'video/mp4'" class="mt-4 text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium 
                    rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" style="cursor:pointer;"
                    type="button" @click="openMultimediaModal(levantamiento)"> Ver video </button>
                  </div>
                  <div class="relative flex py-2 items-center">
                      <div class="flex-grow border-t border-gray-400"></div>
                      <span class="flex-shrink mx-4 text-gray-400">Información</span>
                      <div class="flex-grow border-t border-gray-400"></div>
                  </div>
                  <div class="flex flex-col pt-2">
                    <div class="flex flex-row text-base font-light leading-normal text-gray-600">
                      <div class="font-semibold">Proyecto: </div>
                      <div class="pl-2">{{ levantamiento.proyecto_nombre }}</div>
                    </div>
                    <div class="flex flex-row text-base font-light leading-normal text-gray-600">
                      <div class="font-semibold">Categoría: </div>
                      <div class="pl-2">{{ levantamiento.cat_principal_nombre }}</div>
                    </div>
                    <div class="flex flex-row  text-base font-light leading-normal text-gray-600">
                      <div class="font-semibold">Subcategoría: </div>
                      <div class="pl-2">{{ levantamiento.cat_secundaria_nombre }}</div>
                    </div>
                  </div>
                  <div>
                    <div class="flex flex-row text-sm font-light leading-normal text-gray-600">
                      <div class="font-semibold">Fecha:</div>
                      <div class="pl-2">{{  levantamiento.fecha_levantamiento | moment("DD/MM/YYYY hh:mm a") }}</div>
                    </div>
                    <div class="flex flex-row text-xs font-light leading-normal text-gray-600">
                      <div class="font-semibold">Tipo de geometría:</div>
                      <div class="pl-2">{{ feature.properties.tipo_geometria }}</div>
                    </div>
                    <div class="flex flex-row text-xs font-light leading-normal text-gray-600">
                      <div class="font-semibold">Coords:</div>
                      <div class="pl-2">{{ feature.properties.info_geometria }}</div>
                    </div>
                  </div>
                  <!-- prueba -->
                  <!-- <div class="grid grid-cols-3">
                    <div class="">
                      <div class="text-base font-light leading-normal text-gray-600 font-semibold">
                        <div>Proyecto: </div>
                        <div>Categoría: </div>
                        <div>Subcategoría: </div>
                      </div>
                      <div class="text-sm font-light leading-normal text-gray-600 font-semibold">
                        <div>Fecha:</div>
                      </div>
                      <div class="text-xs font-light leading-normal text-gray-600 font-semibold">
                        <div>Tipo de geometría:</div>
                        <div>Coords:</div>
                      </div>
                    </div>
                    <div class="col-span-2">
                      <div class="text-base font-light leading-normal text-gray-600">
                        <div>{{ levantamiento.proyecto_nombre }}</div>
                        <div>{{ levantamiento.cat_principal_nombre }}</div>
                        <div>{{ levantamiento.cat_secundaria_nombre }}</div>
                      </div>
                      <div class="text-sm font-light leading-normal text-gray-600">
                        <div>{{ levantamiento.fecha_levantamiento | moment("DD/MM/YYYY hh:mm a") }}</div>
                      </div>
                      <div class="text-xs font-light leading-normal text-gray-600">
                        <div>{{ feature.properties.tipo_geometria }}</div>
                        <div>{{ feature.properties.info_geometria }}</div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
              <div v-else style="width: 300px;">
                <div class="pt-2 pb-2">
                  <div v-if="levantamiento.tipo_nombre == 'Oportunidad'" class="flex flex-col items-center text-center" style="color: #6ca929;"> <!--div sección o table row -->
                    <div class="text-xl font-semibold leading-normal">
                      {{ levantamiento.nombre }}
                    </div>
                    <div v-if="levantamiento.descripcion == ''" class="text-xs font-normal italic leading-normal text-justify" style="padding-top: 10px;">
                      {{ levantamiento.descripcion }}
                    </div>
                  </div>
                  <div v-else class="flex flex-col items-center text-center text-cdmx-red"> 
                    <div class="text-xl font-normal leading-normal">
                      {{ levantamiento.nombre }}
                    </div>
                    <div class="text-xs font-light italic leading-normal text-justify" style="padding-top: 10px;">
                      {{ levantamiento.descripcion }}
                    </div>
                  </div>
                  <div v-if="levantamiento.media_folder != null" class="flex flex-col items-center text-center py-5"> 
                    <!-- <div v-if="levantamiento.file_type == 'image/jpeg'" class="font-bold">Imagen:</div> -->
                    <!-- <div v-if="levantamiento.file_type == 'image/jpeg'" class='text-right'>
                      <div v-if="levantamiento.tipo_nombre == 'Oportunidad'" class="rounded-md border-solid border-2 border-cdmx-green">
                        <v-lazy-image :src="levantamiento.imagen" class="max-w-full"/>
                      </div>
                      <div v-else class="rounded-md border-solid border-2 border-cdmx-red">
                        <v-lazy-image :src="levantamiento.imagen" class="max-w-full"/>
                      </div>
                      <small @click="showImage(levantamiento.imagen)" style="cursor: pointer; color: #007bff;">Ver imagen completa</small>
                    </div>
                    <div v-if="levantamiento.file_type == 'video/mp4'">
                      <video
                        :src="levantamiento.video"
                        width="150"
                        height="150"
                        controls
                        controlsList="nodownload"
                      />
                    </div> -->
                    <!-- <div v-if="levantamiento.file_type == 'audio/mpeg'" class="font-bold">Audio:</div> -->
                    <div v-if="levantamiento.file_type == 'audio/mpeg'">
                      <div v-if="levantamiento.tipo_nombre == 'Oportunidad'" class="rounded-full border border-cdmx-green">
                        <audio :src="levantamiento.audio" type=”audio/mp3″ class="max-w-full" controls controlsList="nodownload" />
                      </div>
                      <div v-else class="rounded-full border border-cdmx-red">
                        <audio :src="levantamiento.audio" type=”audio/mp3″ class="max-w-full" controls controlsList="nodownload" />
                      </div>
                    </div>                     
                  </div>
                  <div class="relative flex py-2 items-center">
                      <div class="flex-grow border-t border-gray-400"></div>
                      <span class="flex-shrink mx-4 text-gray-400">Información</span>
                      <div class="flex-grow border-t border-gray-400"></div>
                  </div>
                  <div class="flex flex-col pt-2">
                    <div class="flex flex-row text-base font-light leading-normal text-gray-600">
                      <div class="font-semibold">Proyecto: </div>
                      <div class="pl-2">{{ levantamiento.proyecto_nombre }}</div>
                    </div>
                    <div class="flex flex-row text-base font-light leading-normal text-gray-600">
                      <div class="font-semibold">Categoría: </div>
                      <div class="pl-2">{{ levantamiento.cat_principal_nombre }}</div>
                    </div>
                    <div class="flex flex-row  text-base font-light leading-normal text-gray-600">
                      <div class="font-semibold">Subcategoría: </div>
                      <div class="pl-2">{{ levantamiento.cat_secundaria_nombre }}</div>
                    </div>
                  </div>
                  <div>
                    <div class="flex flex-row text-sm font-light leading-normal text-gray-600">
                      <div class="font-semibold">Fecha:</div>
                      <div class="pl-2">{{  levantamiento.fecha_levantamiento | moment("DD/MM/YYYY hh:mm a") }}</div>
                    </div>
                    <div class="flex flex-row text-xs font-light leading-normal text-gray-600">
                      <div class="font-semibold">Tipo de geometría:</div>
                      <div class="pl-2">{{ feature.properties.tipo_geometria }}</div>
                    </div>
                    <div class="flex flex-row text-xs font-light leading-normal text-gray-600">
                      <div class="font-semibold">Coords:</div>
                      <div class="pl-2">{{ feature.properties.info_geometria }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </l-popup>
        </l-layer-group>
         </template>
      </template>
    </l-map>

    <multimedia-modal :showing="showingMultimediaModal">
      <div v-if="this.levantamientoInfo.file_type == 'video/mp4'">
        <div v-if="this.levantamientoInfo.tipo_nombre == 'Oportunidad'" class="border-solid border-2 border-cdmx-green">
          <video
            :src="this.levantamientoInfo.video"
            controls
            controlsList="nodownload"
            style="height:500px;"
          />
        </div>
        <div v-else>
          <video
            :src="this.levantamientoInfo.video"
            controls
            controlsList="nodownload"
            style="height:500px;"
          />
        </div>
      </div>
      <div v-if="this.levantamientoInfo.file_type == 'image/jpeg'">
        <div v-if="this.levantamientoInfo.tipo_nombre == 'Oportunidad'" class="rounded-md border-solid border-2 border-cdmx-green">
          <v-lazy-image :src="this.levantamientoInfo.imagen" class="max-w-full" style="height:500px;"/>
        </div>
        <div v-else class="rounded-md border-solid border-2 border-cdmx-red">
          <v-lazy-image :src="this.levantamientoInfo.imagen" class="max-w-full" style="height:500px;"/>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-white border-cdmx-red border-3 font-bold
          tracking-wider bg-cdmx-red hover:bg-red-500 float-right"
          @click="showingMultimediaModal = false"
        >Cerrar</button>
      </div>
    </multimedia-modal>

    <filters @click="imgmap" @updateProjects="updateProjects"></filters>
  </div>
</template>

<script>
import L from "leaflet";
import { LMap, LGeoJson, LPopup, LLayerGroup, LIcon, LTileLayer } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import { latLng, icon } from "leaflet";
import filters from "./ExplorerFilter";
import * as turf from '@turf/turf';
import { backend_url } from "../config/url.config.ts";
import MultimediaModal from './MultimediaModal'

export default {
  name: "Explorer",
  data: function () {
    return {
      zoom: 9,
      maxZoom: 22,
      center: [20.58651, -89.01501],
      map: null,
      valor: { selectmap: "traffic" },
      levantamientos: [],
      id_feature_on_screen : 0,

/*       geoStyle: {
        color: "#cb2833",
        fill: true,
      }, */
      mapOptions :{
        zoomControl: false,
      },

      geoJsonOptions : {
 /*        onEachFeature: function (feature, layer) {
          //console.log(feature)
          if(feature.geometry.type == "Point"){
            console.log("point")
          }
          layer.getLatLng = function() { return this.getBounds().getCenter() }
          layer.setLatLng = function() { }
          layer._latlng = layer.getLatLng(); 
        },*/
        pointToLayer: function (feature, latlng) {
              let icon_url = "imgs/pin_azul.png"
              try{
                switch(feature.properties.typeInfo.nombre){
                  case "Oportunidad":
                  case "oportunidad":
                    icon_url= "imgs/pin_verde.png"
                    break;
                  case "Amenaza":
                  case "amenaza":
                    icon_url= "imgs/pin_rojo.png"
                    break;    
                  default:
                    icon_url= "imgs/pin_azul.png"
                    break;  
                }
              }
              catch(err){
                 icon_url= "imgs/pin_azul.png"
              }              

              var greenIcon = L.icon({
                  iconUrl: icon_url,
                  //shadowUrl: 'leaf-shadow.png',
                  iconSize: [30, 30], // size of the icon
                  //iconAnchor: [20, 40]
              });          
              
              return L.marker(latlng, {icon: greenIcon})

          }         
      },      

      urlBaseMap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      imageWidthPopup: 0,
      showingMultimediaModal: false,
      levantamientoInfo: "",
    };
  },
  components: {
    LMap,
    LGeoJson,
    LTileLayer,
    LPopup,
    LLayerGroup,
    filters,
    LIcon,
    MultimediaModal
  },
  watch: {
    "valor.selectmap": function (val) {
      console.log(val)
      console.log("val")
      if (val === "traffic") {
        console.log(val)
        this.urlBaseMap = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        this.attribution =
          '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
      } else {
        console.log("Imagery")
        console.log(val)
        this.urlBaseMap =
          "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
        this.attribution =
          "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community";
      }
    },
  },

  methods: {
    onReady() {
      this.map = this.$refs.map.mapObject;
      // esri.basemapLayer("Topographic").addTo(this.map);
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        // esri.basemapLayer("Topographic").addTo(map);
        this.leafletMap = map;
      });
    },
    imgmap: function (click) {
      if (click.mapa == "traffic") {
        this.valor.selectmap = click.mapa;
      } else if (click.mapa == "satellite") {
        this.valor.selectmap = click.mapa;
      }
    },
    updateProjects(data) {
      let that=this;
      this.id_feature_on_screen = 0;
      console.log("updateProjects")
      console.log(data)
      let levantamientos = data.levantamientos;
      levantamientos.forEach((levantamiento) => {
        //console.log(levantamiento)
        levantamiento.geojson = JSON.parse(levantamiento.geojson);
        //console.log(levantamiento.geojson)
        //console.log(levantamiento.geojson.features[0].geometry.type)

        if((levantamiento.media_folder != null) && (levantamiento.file_type == 'image/jpeg')) {
          levantamiento["imagen"] = backend_url+levantamiento.media_folder.substring(1);
        }
        if((levantamiento.media_folder != null) && (levantamiento.file_type == 'video/mp4')) {
          levantamiento["video"] = backend_url+levantamiento.media_folder.substring(1);
        }
        if((levantamiento.media_folder != null) && (levantamiento.file_type == 'audio/mpeg')) {
          levantamiento["audio"] = backend_url+levantamiento.media_folder.substring(1);
        }

        levantamiento.geojson.features.forEach((feature, index) => {
            this.id_feature_on_screen++
            feature.properties["id"] = this.id_feature_on_screen;
            switch(feature.geometry.type){
              
              case "Point":
                //console.log("es punto")
                feature.properties["tipo_geometria"] = "Punto"
                let position = {lat: feature.geometry.coordinates[0], lng: feature.geometry.coordinates[1] }
                position = 'Latitud: '+feature.geometry.coordinates[0]+', Longitud: '+feature.geometry.coordinates[1]
                //console.log(position)
                feature.properties["info_geometria"] = 'Latitud: '+feature.geometry.coordinates[0]+', Longitud: '+feature.geometry.coordinates[1] 
                break;
              case "LineString":
                //console.log("es linestring")
                feature.properties["tipo_geometria"] = "Línea"
                let longitud = turf.length(feature.geometry, {units: 'kilometers'})

                if(longitud<1){
                  let length_metros = longitud/0.001
                  feature.properties["info_geometria"] = this.thousands_separators(length_metros.toFixed(2)) + " m aprox. "
                }
                else{
                  feature.properties["info_geometria"] = this.thousands_separators(longitud.toFixed(2)) + " km aprox."
                }

                //console.log("longitud = "+longitud+ " kilometos") 
                //feature.properties["info_geometria"] = longitud+ " km aprox."
                break;
              case "Polygon":
                //console.log("es polígono")
                feature.properties["tipo_geometria"] = "Polígono"
                let area = turf.area(feature.geometry) //en m2
                //console.log("área = "+area+" m2")

                let area_ha = area/10000
                feature.properties["info_geometria"] = this.thousands_separators(area_ha.toFixed(2)) +" ha aprox."                


/*                 if(area < 1000000){
                  feature.properties["info_geometria"] = this.thousands_separators(area.toFixed(2)) +" m2 aprox."
                }
                else{
                  let area_kilo = area/1000000
                  this.polygonArea_to_show = this.thousands_separators(area_kilo.toFixed(2)) +" km2 "
                  feature.properties["info_geometria"] = this.thousands_separators(area_kilo.toFixed(2)) +" km2 aprox"
                } */

                break;  
            }        
        })

        //console.log()
      });
      this.levantamientos = levantamientos;
    },
    styleFunction(feature, tipo) {
      //console.log(feature)
      //const fillColor = this.fillColor; // important! need touch fillColor in computed for re-calculate when change fillColor
      let geoStyle;
      let color;
      try{
        switch(tipo){
        //switch(feature.properties.typeInfo.name){
          case "Oportunidad":
          case "oportunidad":
            color = "#366D38"
            break;
          case "Amenaza":
          case "amenaza":
            color = "#cb2833"
            break;    
          default:
            color = "#58A5CC"
            break;  
        }
      }
      catch(err){
        color = "#58A5CC"
      }



      switch(feature.geometry.type){
        
        case "Point":
          geoStyle = {
           // color: color,
           // fill: false,      
          }
          break;
        case "LineString":
          geoStyle = {
            color: color,
            fill: false,            
          }
          break;
        case "Polygon":
          geoStyle = {
            color: color,
            fill: true,            
          }
          break;
      }  
      return geoStyle
    } ,    
    showPopup(levantamiento, feature_id, evt) {

      if((levantamiento.media_metadata) && (levantamiento.file_type != 'audio/mpeg')) {
        console.log(levantamiento.media_metadata.imageWidth)
        let levantamientoOrientation = 
          levantamiento.media_metadata.imageWidth >
          levantamiento.media_metadata.imageHeight
            ? "horizontal"
            : "vertical"
        
        this.imageWidthPopup = 
          levantamientoOrientation === "horizontal" ? "500px" : "300px";
      }

      //console.log(feature_id, evt)
      //console.log(this.$refs.features[index])
      for(let i=0;i<this.$refs.features.length;i++){
        //console.log(this.$refs.features[i].mapObject)
        let objectGeojson = this.$refs.features[i].mapObject.toGeoJSON();
       // console.log(objectGeojson.features[0].properties.id)
        if(objectGeojson.features[0].properties.id == feature_id){
          this.$refs.features[i].mapObject.openPopup(evt.latlng);
          break;
        }
      }

      //this.$refs.features[index].mapObject.openPopup(evt.latlng);
    },
    showImage(image){
      //console.log(image)
      window.open(image, '_blank').focus();
    },
    thousands_separators(num) {
      var num_parts = num.toString().split(".");
      num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return num_parts.join(".");
    },
    openMultimediaModal(levantamiento) {
      this.levantamientoInfo = levantamiento;
      this.showingMultimediaModal = true;
    }
  },
};
</script>

<style>
</style>